"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var Icon_1 = __importDefault(require("../../../../Icon"));

var theme_1 = __importDefault(require("../../../../utils/theme"));

var ButtonRadio_1 = __importDefault(require("../../ButtonRadio")); // import Option from './Option';


var styled_1 = require("./styled");

var Select =
/** @class */
function (_super) {
  __extends(Select, _super);

  function Select(props) {
    var _this = _super.call(this, props) || this;

    _this.getOptionByValue = function (value) {
      var options = _this.props.options;
      return options.find(function (option) {
        return option.value === value;
      }) || {
        label: '',
        value: ''
      };
    };

    _this.resetOptions = function () {
      var _a = _this.props.options,
          options = _a === void 0 ? [] : _a;

      _this.setState({
        options: options
      });
    };

    _this.onChange = function (option) {
      var _a = _this.props.onChange,
          onChange = _a === void 0 ? function () {
        return {};
      } : _a;

      _this.setState({
        isOpen: false,
        option: option,
        searchText: ''
      }, function () {
        onChange(option);
      });
    };

    _this.onSeachTextChange = function (event) {
      if (_this.props.allowSearch) {
        var value = event.target.value;

        _this.setState({
          searchText: value,
          isSearching: true
        });
      }
    };

    _this.focusOnInput = function () {
      _this.input.current.focus();
    };

    _this.onBlur = function () {
      _this.setState({
        isOpen: false,
        isSearching: false
      });
    };

    _this.onFocus = function () {
      _this.setState({
        isOpen: true
      });
    };

    _this.getDisplayLabel = function () {
      var _a = _this.state,
          isOpen = _a.isOpen,
          isSearching = _a.isSearching,
          searchText = _a.searchText,
          option = _a.option;
      var displayLabel = _this.props.displayLabel;

      if (isOpen && isSearching) {
        return searchText;
      }

      return displayLabel !== undefined ? displayLabel : option.label;
    };

    _this.getOptions = function () {
      var options = _this.props.options;
      var _a = _this.state,
          isSearching = _a.isSearching,
          searchText = _a.searchText;

      if (isSearching) {
        var filter_1 = searchText.toLowerCase();
        return options.filter(function (option) {
          return option.value.toLowerCase().includes(filter_1) || option.label.toLowerCase().includes(filter_1) || (option.secondaryLabel || '').toLowerCase().includes(filter_1);
        });
      }

      return options;
    };

    var value = props.value;
    _this.state = {
      isOpen: false,
      isSearching: false,
      searchText: '',
      option: _this.getOptionByValue(value),
      options: props.options
    };
    _this.input = react_1.default.createRef();
    return _this;
  }

  Select.prototype.render = function () {
    var _a = this.state,
        _b = _a.isOpen,
        isOpen = _b === void 0 ? true : _b,
        option = _a.option;
    var displayLabel = this.getDisplayLabel();
    var options = this.getOptions();
    return react_1.default.createElement(styled_1.SelectWrapper, {
      className: "input-wrapper"
    }, react_1.default.createElement(styled_1.SelectBox, {
      "data-test-id": this.props.testId,
      isOpen: isOpen,
      value: option.value
    }, react_1.default.createElement(styled_1.SelectText, {
      ref: this.input,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onChange: this.onSeachTextChange,
      value: displayLabel
    }), react_1.default.createElement(styled_1.SelectIcon, {
      onClick: this.focusOnInput
    }, react_1.default.createElement(Icon_1.default, {
      name: "caret-" + (isOpen ? 'up' : 'down'),
      color: theme_1.default.palette.secondary.background
    }))), react_1.default.createElement(styled_1.DropdownMenu, {
      isOpen: isOpen,
      value: option.value
    }, react_1.default.createElement(ButtonRadio_1.default, {
      options: options,
      onChange: this.onChange,
      orientation: "vertical",
      value: option.value
    })));
  };

  return Select;
}(react_1.PureComponent);

exports.default = Select;